"use strict";
/* tslint:disable: variable-name max-file-line-count */
Object.defineProperty(exports, "__esModule", { value: true });
var EnhancementFactor = require("./enhancement-factor");
var IAPWSIF97 = require("./iapws-if97");
var IAPWS08 = require("./iapws-08");
var IAPWS06 = require("./iapws-06");
var numerics_1 = require("../numerics");
var moist_air_helper_1 = require("./moist-air-helper");
var EPSILON = 0.621945;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <returns>Relative Humidity [%, where 0.5 = 50%]</returns>
function From_HumidityRatio_To_RelativeHumidity(p, t, W) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    var T = t + 273.15; // [°C] -> [K]
    var p_ws;
    if (T >= 273.15) {
        p_ws = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T);
    }
    else {
        p_ws = IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T);
    }
    var f = EnhancementFactor.Get_Enhancement_Factor(p, T, p_ws);
    var p_s = f * p_ws;
    var phi = ((W / EPSILON) * p) / (p_s * (1 + W / EPSILON));
    phi = phi * 100; // [1/1] -> [%, 50=50%]
    return phi;
}
exports.From_HumidityRatio_To_RelativeHumidity = From_HumidityRatio_To_RelativeHumidity;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <returns>[kJ/kg]</returns>
function From_HumidityRatio_To_SpecificEnthalpy(p, t, W) {
    //if (p <= 0)
    //  throw new ArgumentOutOfRangeException("p");
    //var T = t + 273.15; // [°C] -> [K]
    //var h = Get_SpecificEnthalpy_for_HumidityRatio(p, t, W);
    //return h;
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    var T = t + 273.15;
    var psi_w = W / (0.621945 + W);
    var v_bar = moist_air_helper_1.Get_Molar_Volume_of_Moist_Air(p, T, psi_w);
    var h_bar = moist_air_helper_1.Get_Molar_Enthalpy_of_Moist_Air(T, psi_w, v_bar);
    var M_a = 28.966; // [kg/kmol]
    var M_w = 18.015268; // [kg/kmol]
    var M = (1 - psi_w) * M_a + psi_w * M_w;
    var h = (h_bar / M) * (1 + W);
    return h;
}
exports.From_HumidityRatio_To_SpecificEnthalpy = From_HumidityRatio_To_SpecificEnthalpy;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <returns>WetBulb [°C_wb]</returns>
function From_HumidityRatio_To_WetBulb(p, t, W) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    // If 100% humidity then we return directly, this makes it faster and avoids errors caused by rounding
    var rh = From_HumidityRatio_To_RelativeHumidity(p, t, W);
    if (Math.round(rh) >= 100) {
        return t;
    }
    var T = t + 273.15; // [°C] -> [K]
    // Get enthalpy for dry-bulb
    var h = From_HumidityRatio_To_SpecificEnthalpy(p, t, W);
    // Root-function, returns zero for correct guess
    //Func<double, double> rootFunction = (T_wb_guess) => Get_Error_for_WetBulb_guess(p, T_wb_guess, h, W);
    var rootFunction = function (T_wb_guess) {
        var p_wb_ws;
        var h_w;
        if (T_wb_guess >= 273.15) {
            p_wb_ws = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T_wb_guess);
            h_w =
                IAPWSIF97.Get_Specific_Enthalpy_of_Liquid_Water(p, T_wb_guess) / 1000; // [J/kg] -> [kJ/kg]
        }
        else {
            p_wb_ws =
                IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T_wb_guess);
            h_w = IAPWS06.Get_Specific_Enthalpy_of_Ice(p, T_wb_guess) / 1000; // [J/kg] -> [kJ/kg]
        }
        var f_wb = EnhancementFactor.Get_Enhancement_Factor(p, T_wb_guess, p_wb_ws);
        var p_wb_s = f_wb * p_wb_ws;
        var W_wb_s = (EPSILON * p_wb_s) / (p - p_wb_s);
        var h_wb_s = From_HumidityRatio_To_SpecificEnthalpy(p, T_wb_guess - 273.15, W_wb_s);
        var error = h_wb_s + (W - W_wb_s) * h_w - h;
        return error;
    };
    // Get initial bounds
    // If dry-bulb is below the saturation temperature of water for the given atmospheric pressure
    // then max wet-bulb is the dry-bulb, otherwise max wet-bulb is the saturation temperature.
    var T_wb_max = T;
    var T_sat = IAPWSIF97.Get_Saturation_Temperature_of_Water(p);
    if (T > T_sat) {
        T_wb_max = T_sat - 0.1;
    }
    // Decrease the lower bound until you get below the actual wet-bulb temperature
    var T_wb_min = T_wb_max;
    //while (Get_Error_for_WetBulb_guess(p, T_wb_min, h, W) * Get_Error_for_WetBulb_guess(p, T_wb_max, h, W) > 0)
    var T_wb_max_err = rootFunction(T_wb_max);
    while (rootFunction(T_wb_min) * T_wb_max_err > 0) {
        T_wb_min -= 10;
    }
    // Solve iteratively
    //var T_wb = BisectionMethod.Solve(rootFunction, T_wb_min, T_wb_max, 1e-8);
    var T_wb = numerics_1.BrentsMethod.solve(rootFunction, T_wb_min, T_wb_max, 1e-3);
    if (T_wb.Result === null) {
        throw new Error(T_wb.ErrorText);
    }
    // Return
    var t_wb = T_wb.Result - 273.15; // [K] -> [°C]
    return t_wb;
}
exports.From_HumidityRatio_To_WetBulb = From_HumidityRatio_To_WetBulb;
/// <param name="p">Pressure [Pa]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <returns>Dew-point [°C_dp]</returns>
function From_HumidityRatio_To_DewPoint(p, W) {
    // Make sure it isn't dry air, return an impossible temperature otherwise
    var psi_w = W / (EPSILON + W);
    if (1 - psi_w < 1e-16) {
        return -1;
    }
    var p_w = psi_w * p;
    // The highest dewpoint temperature possible is the dry-bulb temperature.
    // When they are equal, the air is saturated (RH=100%)
    // A good guess for Tdp is that enhancement factor is unity, which yields
    // p_w_s = p_w, and get guess for T from saturation temperature
    // Root-function, returns zero for correct guess
    var rootFunction = function (T_dp) {
        // Saturation or sublimation pressure at dewpoint
        var p_ws_dp;
        if (T_dp >= 273.15) {
            p_ws_dp = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T_dp);
        }
        else {
            p_ws_dp =
                IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T_dp);
        }
        // Enhancement Factor at dewpoint temperature
        var f_dp = EnhancementFactor.Get_Enhancement_Factor(p, T_dp, p_ws_dp);
        // Error between target and actual pressure [kPa]
        var resid = p_w - p_ws_dp * f_dp;
        return resid;
    };
    // Iteratively find the dewpoint temperature
    var t_found = numerics_1.BrentsMethod.solve(rootFunction, 0.00001, 600, 1e-8);
    if (t_found.Result === null) {
        throw new Error(t_found.ErrorText);
    }
    var t_dp = t_found.Result - 273.15; // [K] -> [C]
    return t_dp;
}
exports.From_HumidityRatio_To_DewPoint = From_HumidityRatio_To_DewPoint;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="rh">Relative Humidity [%, where 0.5 = 50%]</param>
/// <returns>Humidity Ratio [kg/kg]</returns>
function To_HumidityRatio_From_RelativeHumidity(p, t, rh) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    var T = t + 273.15; // [°C] -> [K]
    rh = rh / 100; // [%, 50=50%] -> [1/1]
    var p_ws;
    if (T >= 273.15) {
        p_ws = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T);
    }
    else {
        p_ws = IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T);
    }
    var f = EnhancementFactor.Get_Enhancement_Factor(p, T, p_ws);
    var p_s = f * p_ws;
    var W = (EPSILON * (rh * p_s)) / (p - rh * p_s);
    //if (W < 0)
    //  throw new ArgumentOutOfRangeException("t");
    return W;
}
exports.To_HumidityRatio_From_RelativeHumidity = To_HumidityRatio_From_RelativeHumidity;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="t_wb">Wet-bulb [°C_wb]</param>
/// <returns>Humidity Ratio [kg/kg]</returns>
function To_HumidityRatio_From_WetBulb(p, t, t_wb) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    var T_wb = t_wb + 273.15; // [°C] -> [K]
    var T = t + 273.15; // [°C] -> [K]
    // Get values that are constant for all interations
    var ret;
    if (T_wb >= 273.15) {
        ret = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T_wb);
    }
    else {
        ret = IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T_wb);
    }
    var p_wb_ws = ret;
    var f_wb = EnhancementFactor.Get_Enhancement_Factor(p, T_wb, p_wb_ws);
    var p_wb_s = f_wb * p_wb_ws;
    var W_wb_s = (EPSILON * p_wb_s) / (p - p_wb_s);
    var h_wb_s = From_HumidityRatio_To_SpecificEnthalpy(p, T_wb - 273.15, W_wb_s);
    var h_wb_w;
    if (T_wb >= 273.15) {
        h_wb_w = IAPWSIF97.Get_Specific_Enthalpy_of_Liquid_Water(p, T_wb) / 1000; // [J/kg] -> [kJ/kg]
    }
    else {
        h_wb_w = IAPWS06.Get_Specific_Enthalpy_of_Ice(p, T_wb) / 1000; // [J/kg] -> [kJ/kg]
    }
    // Initial guess
    var W_guess = 0.001;
    // Root-function, returns zero for correct guess
    var rootFunction = function (W) {
        // Get enthalpy for dry-bulb
        var h = From_HumidityRatio_To_SpecificEnthalpy(p, T - 273.15, W);
        var error = h_wb_s + (W - W_wb_s) * h_wb_w - h;
        return error;
    };
    // Iteratively find W
    var W_found = numerics_1.SecantMethod.solve(rootFunction, W_guess, 1e-8, 0.1);
    return W_found;
}
exports.To_HumidityRatio_From_WetBulb = To_HumidityRatio_From_WetBulb;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="h">Specific Enthalpy [kJ/kg]</param>
/// <returns>Humidity Ratio [kg/kg]</returns>
function To_HumidityRatio_From_Enthalpy(p, t, h) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    // const T = t + 273.15; // [°C] -> [K] - never used in C# either
    // Initial guess
    var W_guess = 0.001;
    // Root-function, returns zero for correct guess
    var rootFunction = function (W) {
        return From_HumidityRatio_To_SpecificEnthalpy(p, t, W) - h;
    };
    // Iteratively find W
    var W_found = numerics_1.SecantMethod.solve(rootFunction, W_guess, 1e-8, 0.1);
    return W_found;
}
exports.To_HumidityRatio_From_Enthalpy = To_HumidityRatio_From_Enthalpy;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t_d">Dew-point Temperature [°C_dp]</param>
/// <returns>Humidity Ratio [kg/kg]</returns>
function To_HumidityRatio_From_DewPoint(p, t_d) {
    if (p <= 0) {
        throw new Error("ArgumentOutOfRangeException: p");
    }
    var T_d = t_d + 273.15; // [°C] -> [K]
    // Saturation or sublimation pressure at dewpoint
    var p_ws_dp;
    if (T_d >= 273.15) {
        p_ws_dp = IAPWSIF97.Get_Saturation_Pressure_of_Pure_Water(T_d);
    }
    else {
        p_ws_dp =
            IAPWS08.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T_d);
    }
    // Enhancement Factor at dewpoint temperature
    var f_dp = EnhancementFactor.Get_Enhancement_Factor(p, T_d, p_ws_dp);
    var p_w = p_ws_dp * f_dp;
    // Initial guess..... how to get a good one? Can we get W at saturation somehow?
    if (p_w >= p) {
        throw new Error("Dewpoint undefined.");
    }
    return (EPSILON * p_w) / (p - p_w);
}
exports.To_HumidityRatio_From_DewPoint = To_HumidityRatio_From_DewPoint;
/// <param name="p">Pressure [Pa]</param>
/// <param name="t">Temperature [°C] </param>
/// <param name="rh">Relative humidity [%]</param>
/// <returns>[kJ/kg]</returns>
function From_RelativeHumidity_To_SpecificEnthalpy(p, t, rh) {
    var w = To_HumidityRatio_From_RelativeHumidity(p, t, rh);
    return From_HumidityRatio_To_SpecificEnthalpy(p, t, w);
}
exports.From_RelativeHumidity_To_SpecificEnthalpy = From_RelativeHumidity_To_SpecificEnthalpy;
